export const MOBILE_BREAKPOINT = '767px'
export const MOBILE_BREAKPOINT_RESERVATION = 768

/** Hub shell sidebar rail / expand breakpoint (matches Bootstrap `sm`). */
export const HUB_SIDEBAR_MOBILE_BREAKPOINT_PX = 576
export const HUB_SIDEBAR_MOBILE_BREAKPOINT = `${HUB_SIDEBAR_MOBILE_BREAKPOINT_PX}px`

/** Expanded and collapsed hub sidebar widths (icon rail when closed). */
export const HUB_SIDEBAR_WIDTH_OPEN = '255px'
export const HUB_SIDEBAR_WIDTH_COLLAPSED = '43px'
